export { default as vuetify } from './vuetify'
export { default as fontawesome } from './fontawesome'
import firebase from 'firebase/compat'

import moment from 'moment'

import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'

const opts = {
	load: {
		key: process.env.VUE_APP_API_GOOGLE_MAPS_KEY,
		libraries: 'places',
	},
}

const configOptions = {
	apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
	authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
	databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
	projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
	storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
	messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
}

firebase.initializeApp(configOptions)

Vue.prototype.$moment = moment
Vue.use(VueGoogleMaps, opts)
